module.exports = __webpack_public_path__ + "static/img01-e19988b0eb71a69726677b52ce2855bc.jpg";